<!-- Localized -->
<template>
  <div
    class="flex flex-col border-r pr-4 border-solid border-gray-200 m-container"
  >
    <div class="flex justify-between align-baseline" id="header">
      <p class="text-base-content-300 mb-0 text-sm grow">{{ title }}</p>
      <!-- <EditPencil @click="handleEditClick" class="cursor-pointer"/> -->
    </div>
    <p
      v-if="this.$route.meta.showLightRay"
      class="font-semibold text-sm capitalize"
      :class="!value && 'text-gray-400'"
    >
      {{ lightRayCaseId || getCaseFromSessionStorage }}
    </p>
    <div v-else class="flex w-full items-center justify-between">
      <div
        class="font-semibold text-sm capitalize"
        :class="!value && 'text-gray-400'"
      >
        {{ value }}
      </div>
      <div
        v-if="edit"
        class="items-center pt-1 cursor-pointer"
        @click="handleEditCaseName"
      >
        <EditPencil class="h-5 w-5" />
      </div>
      <div
        v-if="checkPermission('case.read_duplicate_entities') && duplicate && getDuplicateEntitiesList && getDuplicateEntitiesList.case_entities?.length > 0"
        class="items-center pt-1 cursor-pointer h-5 w-5"
        @click="!isLoading && handleDuplicateCheck()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" :class="{ 'svg-blur': isLoading }">
        <mask id="mask0_264_8609" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_264_8609)">
        <path d="M8.20024 14.44C7.39024 14.12 6.72274 13.6175 6.19774 12.9325C5.67274 12.2475 5.35524 11.47 5.24524 10.6H6.46024C6.55024 11.13 6.74524 11.615 7.04524 12.055C7.34524 12.495 7.73024 12.85 8.20024 13.12V14.44ZM10.3002 16C10.0502 16 9.83774 15.9125 9.66274 15.7375C9.48774 15.5625 9.40024 15.35 9.40024 15.1V11.5C9.40024 11.25 9.48774 11.0375 9.66274 10.8625C9.83774 10.6875 10.0502 10.6 10.3002 10.6H11.6202C11.7702 10.6 11.9127 10.635 12.0477 10.705C12.1827 10.775 12.2902 10.875 12.3702 11.005L12.7002 11.5H15.1002C15.3502 11.5 15.5627 11.5875 15.7377 11.7625C15.9127 11.9375 16.0002 12.15 16.0002 12.4V15.1C16.0002 15.35 15.9127 15.5625 15.7377 15.7375C15.5627 15.9125 15.3502 16 15.1002 16H10.3002ZM4.90024 9.4C4.65024 9.4 4.43774 9.3125 4.26274 9.1375C4.08774 8.9625 4.00024 8.75 4.00024 8.5V4.9C4.00024 4.65 4.08774 4.4375 4.26274 4.2625C4.43774 4.0875 4.65024 4 4.90024 4H6.22024C6.37024 4 6.51274 4.035 6.64774 4.105C6.78274 4.175 6.89024 4.275 6.97024 4.405L7.30024 4.9H9.70024C9.95024 4.9 10.1627 4.9875 10.3377 5.1625C10.5127 5.3375 10.6002 5.55 10.6002 5.8V8.5C10.6002 8.75 10.5127 8.9625 10.3377 9.1375C10.1627 9.3125 9.95024 9.4 9.70024 9.4H4.90024ZM13.6002 10C13.6002 9.35 13.4402 8.7475 13.1202 8.1925C12.8002 7.6375 12.3602 7.2 11.8002 6.88V5.56C12.7102 5.93 13.4377 6.5175 13.9827 7.3225C14.5277 8.1275 14.8002 9.02 14.8002 10H13.6002ZM10.6002 14.8H14.8002V12.7H12.0552L11.4552 11.8H10.6002V14.8ZM5.20024 8.2H9.40024V6.1H6.65524L6.05524 5.2H5.20024V8.2Z" fill="#0D69D5"/>
        </g>
        </svg>
      </div>
    </div>
    <ModalContent
      name="editCaseName"
      :ref="modalRefName"
      :title="$t('components.case_name')"
      :max-width="350"
      @close="closeModal"
      clickToClose
      :disabled="!caseName"
      @submit="submitCaseName"
      v-if="edit"
    >
      <template #content>
        <div class="flex flex-col flex-wrap max-w-xs gap-4">
          <FormulateInput
            class="w-full pb-2"
            :label="$t('components.case_name')"
            :placeholder="$t('components.case_name')"
            type="text"
            validation="required"
            v-model="caseName"
          />
        </div>
      </template>
    </ModalContent>
     <ModalContent
        name="duplicate-entity-incase-unique"
        v-if="rows && rows.length > 0"
        :ref="duplicateModal"
        :title="$t('case_entity.creation.potential_matches_were_found_against_this_entity')"
        width="70%"
        height="80%"
        darkContent
        close
         @closed="onClose"
        >

            <template #content  >
            <!-- <Loader v-if="isCloning" loadingText="Cloning Field..." /> -->
              <entity-tool-bar-container
              :caseEntitiesData="getDuplicateEntitiesList"
              :items="entityList"
              :duplicateEntityId = "entityId"
              :plus-disabled="true"
              :editable="false"
              :show-plus="false"
              @onEntityTabClick="handleEntityTabClick($event)"
            />
            <div class="custom-table-container">
                <table class="custom-table">
                  <thead>
                    <tr>
                      <th>{{ idLabel }}</th>
                      <th v-if="getUserType !== 'CLIENT_INTERNAL'">{{ clientNameLabel }}</th>
                      <th>{{ usersWithAccessLabel }}</th>
                      <th>{{ packageNameLabel }}</th>
                      <th>{{ nameLabel }}</th>
                      <th v-if="entityType.toLowerCase() === 'company'">{{ emailLabel }}</th>
                      <th v-if="entityType.toLowerCase() === 'company'">{{ dunsNumberLabel }}</th>
                      <th v-if="entityType.toLowerCase() === 'person'">{{ countryLabel }}</th>
                      <th colspan="3" class="dob-header" v-if="entityType.toLowerCase() === 'person'">
                        {{ dobLabel }}
                        <div class="dob-subheaders">
                          <span>Day</span>
                          <span>Month</span>
                          <span>Year</span>
                        </div>
                      </th>
                      <th colspan="3" class="dob-header" v-if="entityType.toLowerCase() === 'company'">
                        {{ incorporationDateLabel }}
                        <div class="dob-subheaders">
                          <span>Day</span>
                          <span>Month</span>
                          <span>Year</span>
                        </div>
                      </th>
                      <th v-if="entityType.toLowerCase() === 'company'">{{ countryLabel }}</th>
                      <th v-if="entityType.toLowerCase() === 'company'">{{ companyNumberLabel }}</th>
                      <th v-if="entityType.toLowerCase() === 'person'">{{ emailLabel }}</th>
                    </tr>
                    </thead>
                  <tbody>
                   <tr v-for="(row, index) in rows" :key="`${row.case_id}-${index}`">
                      <td>
                        <a :href="`/case/${row.case_id}/profile-view?clientId=${row.client_id}&caseid=${row.case_uuid}&entityId=${row.case_entity_id}`" 
                          target="_blank" 
                          rel="noreferrer" 
                          class="text-blue-600 no-underline font-bold">
                          {{ row.case_id }}
                        </a>
                      </td>
                      <td v-if="getUserType !== 'CLIENT_INTERNAL'">{{ row.client_name }}</td>
                      <td>{{ row.access_users && Array.isArray(row.access_users) ? row.access_users.join(', ') : '' }}</td>
                      <td>{{ row.package_name }}</td>
                      <td>{{ row.match_status }}</td>
                      <td v-if="entityType.toLowerCase() === 'person'">{{ row.country }}</td>
                      <td v-if="entityType.toLowerCase() === 'company'"> {{row.email_address}}</td>
                      <td v-if="entityType.toLowerCase() === 'company'"> {{row.duns_number}}</td>
                      <td class="dob-cell">{{ row.day }}</td>
                      <td class="dob-cell">{{ row.month }}</td>
                      <td class="dob-cell">{{ row.year }}</td>
                      <td v-if="entityType.toLowerCase() === 'company'"> {{row.country}}</td>
                      <td v-if="entityType.toLowerCase() === 'company'"> {{row.company_number}}</td>
                      <td v-if="entityType.toLowerCase() === 'person'">{{ row.email_address }}</td>
                    </tr>
                  </tbody>
                </table>
            </div>       
            </template>
            <template #footer>
            <footer class="flex items-center w-full justify-between pt-4 border-t border-0 border-solid border-gray-200">
                    <div  class="flex ml-auto">
                        <button
                        class="h-9  cursor-pointerborder-none rounded-xl text-base text-white-text flex justify-center items-center font-semibold ml-auto p-5"
                        :class="[isSubmitDisabled ? 'bg-gray-500 cursor-not-allowed pointer-events-none' :'bg-primary cursor-pointer hover:bg-primary-600']" @click ="onClose()"
                        > {{$t('general.ok')}}
                        </button>
                    </div>
            </footer>
            </template>
        </ModalContent>
  </div>
</template>

<script>
const EditPencil = () => import("@shared/assets/svg/editIconBlue.svg");
import ModalContent from "@shared/modal-content";
import axios from "@/axios";
import {  mapActions } from "vuex";
import { EntityToolBarContainer } from "@shared/case-entities";
import { mapGetters} from "vuex";
import {
  getEntityTypeName,
  getShortEntityData,
} from "@shared/utils/functions";

import PersonIcon from "@shared/assets/icons/entity/person.svg";
import CompanyIcon from "@shared/assets/icons/entity/company.svg";
import { checkPermission } from "@shared/utils/functions";

export default {
    components: {
        EditPencil,
        ModalContent,
        EntityToolBarContainer
        // EditIcon
    },
    props: {
        title: {
          type: String,
          default: "",
        },
        value: {
          type: String,
          default: "",
        },
        entityType: {
          type: String,
          default: "",
        },
        edit: {
          type: Boolean,
          default: false,
        },
        duplicate: {
          type: Boolean,
          default: false,
        },
        isSubmitDisabled: {
          type: Boolean,
          default: false,
        },
        getDuplicateEntitiesList: {
          type: Object,
        },
    },

    data() {
        return {
          caseName: "",
          modalRefName: "caseNameEdit",
          duplicateModal: "duplicate-entity-incase-unique",
          isLoading: false,
          loadingState: {
              pendingApproval: false,
          },
          rows:[],
          entity: "",
          entityName: "",
          entityList:[],
          caseId: "",
          entityId: "",
        };
    },
    computed: {
        ...mapGetters({
          getCaseEntitiesData: "getCaseEntitiesData", getUserType: "getUserType",
        }),
        lightRayCaseId() {
          return this.$store.getters.getLightRayCaseId;
        },
        
        getCaseFromSessionStorage() {
          return sessionStorage.getItem("neo_case_id");
        },
        idLabel() {
        return this.$t('case_entity.creation.id');
        },
        clientNameLabel() {
          return this.$t('components.client_name');
        },
        usersWithAccessLabel() {
          return this.$t('case_entity.creation.users_with_access');
        },
        packageNameLabel() {
          return this.$t('pages.workflow_engine.package_name');
        },
        nameLabel() {
          return `${this.$t('components.tenant.email_template_modal.name')} (${this.entityName})`;
        },
        emailLabel() {
          return this.$t('pages.user_details.email');
        },
        dunsNumberLabel() {
          return this.$t('components.tools.company_identifier.company_info.duns_number');
        },
        countryLabel() {
          return this.$t('profile_view.sources_columns.country');
        },
        dobLabel() {
          return this.$t('components.saas.adverse_media.lexis_bridger.dob');
        },
        incorporationDateLabel() {
          return this.$t('components.tools.company_identifier.incorporation_date');
        },
        companyNumberLabel() {
          return this.$t('components.light_ray.company_number');
        },
        mainEntities() {
          if (!this.getCaseEntitiesData) return [];
          const { case_entities = [] } = this.getCaseEntitiesData;
          return case_entities
            .map((entity) => ({
              ...this.getShortEntityData(entity),
              relations: [],
            }))
            .filter((entity) => entity.entity_type !== "Case");
        },
        entityTypeToIcon() {
          return {
            Person: PersonIcon,
            Company: CompanyIcon,
          };
        },
    },
    watch: {
        entityType: {
          immediate: true,
          handler(newVal) {
            this.entity = newVal;
          }
        },
        getDuplicateEntitiesList: {
          immediate: true,
          handler(newVal) {
            if (newVal) {
              return newVal
            }
          },
        },
    },
    created() {
        this.entity = this.entityType;
    },

    methods: {
        ...mapActions(["fetchCaseData"]),
        
        checkPermission,
        handleEditCaseName() {
          this.caseName = this.value
          this.$refs[this.modalRefName].showModal();
        },
        getEntityTypeName(entity) {
          return getEntityTypeName(this.getCaseEntitiesData, entity);
        },
        getShortEntityData(entity) {
          return getShortEntityData(this.getCaseEntitiesData, entity);
        },
      
        handleEntityTabClick(details) {
          this.entityType = details.entity_type;
          this.caseId = details.case_id;
          this.entityId = details.id;
          if (checkPermission('case.read_duplicate_entities'))
            this.getDuplicateEntities();
        },
        
        async handleDuplicateCheck() {
          this.isLoading = true;
          this.entity = this.entityType;
          this.fillEntityBarData(false);
          if (checkPermission('case.read_duplicate_entities'))
            this.getDuplicateEntities();
        },
        closeModal() {
          this.$refs[this.modalRefName].hideModal();
        },
        async submitCaseName() {
          try {
            if (!this.$route.query.caseid) {
              return;
            }
            const url = `/case/${this.$route.query.caseid}`;
            const response = await axios.put(url, {
              case_name: this.caseName,
            });
            if (response) {
              this.$toast.success(
                response?.data?.message || this.$t('general.update_success')
              );
            }
            await this.fetchCaseData(this.$route.query.caseid);
            this.closeModal();
          } catch (err) {
            console.log("err", err);
            this.$toast.error(
              err?.response?.data?.detail || this.$t("general.default_error")
            );
            this.closeModal();
          }
        },
        fillEntityBarData(silent) {
          const { case_entities } = this.getDuplicateEntitiesList;
          const firstEntity = this.getDuplicateEntitiesList?.case_entities?.[0];
          this.caseId = firstEntity?.case_id || "";
          this.entityId  = firstEntity?.id || "";
          this.entityType = firstEntity?.entity_type || "";
          if (!silent && case_entities) {
            this.entityList = [];
            this.entityList.push(
              ...case_entities.map((entity) => {
                if(entity.is_duplicate){
                const entityType = this.getEntityTypeName(entity);

                return {
                  ...entity,
                  name: entity.entity_name,
                  entity_type: entityType,
                  selected: entity.id === this.entityId,
                  component: this.entityTypeToIcon[entityType],
                };
                }
              })
            );
          } else {
            this.entityList.forEach((entity) => {
              const entityName = case_entities.find((x) => x.id == entity.id)
                ?.entity_name;
              entity.entity_name = entityName || "";
              entity.name = entityName || "";
            });
          }
        },
      
        onClose() {
          if (this.$refs[this.duplicateModal]) {
            this.$refs[this.duplicateModal].hideModal();
            this.rows = [];
            this.entityName = "";
          }
        },
        async getDuplicateEntities() {
          this.loadingState.pendingApproval = true;
          
    
          if(this.caseId && this.entityId) {
            const url = `/case/form/${this.caseId}/entity/${this.entityId}/duplicate-entities`;
            await axios
              .get(url)
              .then((response) => {
                this.rows = response.data.data;
                this.entityName = response.data.entity_name;
                this.loadingState.pendingApproval = false;
                
                // Show modal if rows exist
                if (this.rows && this.rows.length > 0) {
                  setTimeout(() => {
                    this.$refs[this.duplicateModal].showModal();
                    this.isLoading = false;
                  }, 10);
                }
                })
              .catch((error) => {
                console.log("error", error);
              });
          } else {
            this.loadingState.pendingApproval = false;
            this.rows = []
          }
        },
    }
};
</script>

<style>
.m-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  min-width: 150px;
}
#header {
  min-width: inherit;
}

.custom-table-container {
  width: 100%;
  overflow-x: auto;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
}

.custom-table th, .custom-table td {
  padding: 8px;
  border: 1px solid #ddd;
  text-align: left;
}

.custom-table th {
  background-color: #f8f9fa;
  font-weight: bold;
}

.dob-header {
  position: relative;
  padding-bottom: 30px !important;
  text-align: center;
}

.svg-blur {
  filter: blur(1px);
  opacity: 0.6;
  pointer-events: none;
}

.dob-subheaders {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  border-top: 1px solid #ddd;
  padding-top: 5px;
  font-weight: normal;
  font-size: 0.9em;
}

.dob-cell {
  text-align: center;
}

    

</style>
